// libs
import { create } from 'zustand';
// constants
import { INITIAL_STATE } from './constants';
const useDashboardStore = create((set, get) => (Object.assign(Object.assign({}, structuredClone(INITIAL_STATE)), { setAggregatedMetrics: (aggregatedMetrics) => {
        set({ aggregatedMetrics });
    }, setActiveCampaigns: (activeCampaigns) => set({ activeCampaigns }), setCampaignsPerformanceData: (data) => {
        const campaignPerformance = structuredClone(get().campaignsPerformance);
        return set({
            campaignsPerformance: Object.assign(Object.assign({}, campaignPerformance), { data }),
        });
    }, setSelectedRange: (selectedRange) => {
        const campaignPerformance = structuredClone(get().campaignsPerformance);
        return set({
            campaignsPerformance: Object.assign(Object.assign({}, campaignPerformance), { selectedRange }),
        });
    }, clear: () => set(Object.assign({}, structuredClone(INITIAL_STATE))) })));
export default useDashboardStore;
